export const SUPPORT_REDIRECT_URL =
  "https://help.tcgplayer.com/hc/en-us/requests/new";

export const SUPPORT_URL =
  "https://help.tcgplayer.com/hc/en-us/categories/15672013221783";

export const SUPPORT_PRICE_SETTINGS_ARTICLE_URL =
  "https://help.tcgplayer.com/hc/en-us/articles/16007140992791-Price-Settings-and-Updates";
